import { Component, AfterViewInit, Renderer, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { JhiEventManager } from 'ng-jhipster';

import { LoginService } from '../../services';
import { StateStorageService } from '../../shared';
import { AUTHENTICATION_SUCCESS } from '../../shared/constants';
import { Credentials } from '../../models';

@Component({
    selector: 'qms-login',
    templateUrl: './login.component.html'
})
export class LoginComponent implements AfterViewInit {
    private static SERVICE_URL = 'https://sk.pg.edu.pl';

    public credentials: Credentials;

    constructor(private eventManager: JhiEventManager,
                private loginService: LoginService,
                private stateStorageService: StateStorageService,
                private elementRef: ElementRef,
                private renderer: Renderer,
                private router: Router,
                public activeModal: NgbActiveModal) {
        this.credentials = new Credentials(null, null, false);
    }

    ngAfterViewInit() {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#username'), 'focus', []);
    }

    public clear() {
        this.credentials.username = null;
        this.credentials.password = null;
        this.credentials.rememberMe = false;
        this.activeModal.dismiss('cancel');
    }

    login() {
        this.loginService.login(this.credentials).then(() => {
            this.activeModal.close('login success');

            if (this.router.url === '/register' || (/activate/.test(this.router.url)) ||
                this.router.url === '/finishReset' || this.router.url === '/requestReset') {
                this.router.navigate(['']);
            }

            this.eventManager.broadcast({
                name: AUTHENTICATION_SUCCESS,
                content: 'Sending Authentication Success'
            });

            // previousState was set in the authExpiredInterceptor before being redirected to login modal.
            // since login is successful, go to stored previousState and clear previousState
            const redirect = this.stateStorageService.getUrl();
            if (redirect) {
                this.router.navigate([redirect]);
            }
        });
    }

    // TODO: Maybe needed later
    // register() {
    //     this.activeModal.close('to state register');
    //     this.router.navigate(['/register']);
    // }

    public externalLogin() {
        this.activeModal.close('login external redirect');
        window.location.href = `https://logowanie.pg.gda.pl/login?service=${LoginComponent.SERVICE_URL}`;
    }

    // TODO: handle this after CUI integration
    requestResetPassword() {
        this.activeModal.dismiss('to state requestReset');
        this.router.navigate(['/reset', 'request']);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/login/login.component.ts